import "../css/modal.css";
import { useState } from "react";
import { motion } from "framer-motion";

function Modal(props) {
  const [state, setState] = useState(false);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("wrapper-contentcard")) {
      setState(false);
    }
  };

  return (
    <>
      <p className="modal-open flex" onClick={() => setState(true)}>
        <span class="link-with-arrow">{props.title} </span> 
      </p>

      {state && (
        <motion.div
          className="wrapper-contentcard"
          initial={{ y: 100, opacity: 0 }}
          animate={{
            y: 0,
            opacity: 1,
            transition: { type: "spring", stiffness: 200 },
          }}
          onClick={handleOutsideClick}
        >
          <div className="modal-container">
            <span
              className="material-icons close-modalcard"
              onClick={() => setState(false)}
            >
              close
            </span>
            {props.content}
          </div>
        </motion.div>
      )}
    </>
  );
}

export default Modal;
